// istanbul ignore file

import styled from 'styled-components';

export const BannerWrapper = styled.div`
    width: auto;
`;

export const StyledBodyContainer = styled.div`
    padding: 24px;

    body:has(.MuiDrawer-root) & {
        max-height: 650px;
        min-height: 700px;
    }
`;
